export default [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  746,
  727,
  694,
  649,
  589,
  567,
  549,
  531,
  505,
  497,
  490,
  474,
  458,
  448,
  438,
  424,
  406,
  393,
  388,
  376,
  361,
  351,
  342,
  332,
  320,
  311,
  303,
  292,
  285,
  277,
  271,
  262,
  258,
  255,
  252,
  247,
  241,
  235,
  227,
  222,
  218,
  210,
  201,
  199,
  197,
  186,
  184,
  183,
  180,
  178,
  175,
  172,
  168,
  162,
  160,
  158,
  152,
  149,
  147,
  146,
  144,
  142,
  140,
  137,
  134,
  129,
  127,
  124,
  121,
  118,
  115,
  112,
  108,
  104,
  95,
  85,
  80,
];
